import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import css from './NavBar.module.css';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <header className={css.navbar}>
      <div className={css['navbar-inner']}>
        <a href="/" className={css['navbar-logo']}>
            <img src="/scooter-logo.png" alt="Bird Motorbike - Scooter rental Phuket" />
        </a>

       

        <button
          type="button"
          className={css['navbar-toggle']}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          className={`${css['navbar-links']} ${
            menuOpen ? css['navbar-links-open'] : ''
          }`}
        >
          <a href="#scooters">{t('nav.ourScooters')}</a>
          <a href="#why-choose-us">{t('nav.whyChooseUs')}</a>
          <a href="#how-it-works">{t('nav.howItWorks')}</a>
          <a href="#pricing">{t('nav.pricing')}</a>
          <a href="#delivery">{t('nav.delivery')}</a>
          <a href="#reviews">{t('nav.reviews')}</a>
          <a href="#faq">{t('nav.faq')}</a>
          <div className={css['navbar-lang-mobile']}>
            <LanguageSwitcher />
          </div>
        </nav>

        <a
          href="https://wa.me/66943672385"
          target="_blank"
          rel="noopener noreferrer"
          className={css['navbar-whatsapp']}
        >
          <svg
            className={css['navbar-whatsapp-icon']}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          {t('nav.whatsapp')}
        </a>

        <div className={css['navbar-lang-desktop']}>
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
}

export default NavBar;
